/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState } from 'react';
import {
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  Table,
  TableColumnReordering,
} from '@devexpress/dx-react-grid-material-ui';
import { useTemplate } from '../../hooks';
import { getRowId } from '../../common';
import { currencyFormatter } from '../../Shared/colorFormat';
import { Paper, Typography } from '@material-ui/core';
import { TableComponent } from '../../Shared/TableComponent';
import { getColumns } from '../../common/columns';

const RentitemsStockAlsardal = (props: any) => {
  const { rentitems, isRTL, words } = props;
  const { tempoptions } = useTemplate();
  const col = getColumns({ isRTL, words });

  const [columns] = useState(
    [
      tempoptions?.barcode && { name: 'barcode', title: words.code },
      col.name,
      { name: 'price', title: words.theprice },
      { name: 'unit', title: words.unit },
      { name: 'qty', title: isRTL ? 'العدد الكلي' : 'Quantity' },
      { name: 'busy_qty', title: isRTL ? 'المشغول' : 'Busy' },
      { name: 'stock_qty', title: isRTL ? 'المتوفر' : 'Available' },
      col.category,
      { name: 'desc', title: words.description },
    ].filter((x) => x)
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: 'barcode', width: 150 },
    { columnName: col.name.name, width: 250 },
    { columnName: 'price', width: 150 },
    { columnName: 'unit', width: 150 },
    { columnName: 'qty', width: 150 },
    { columnName: 'busy_qty', width: 150 },
    { columnName: 'stock_qty', width: 150 },
    { columnName: col.category.name, width: 150 },
    { columnName: 'desc', width: 250 },
  ]);

  return (
    <Paper
      elevation={2}
      style={{
        overflow: 'auto',
        height: 400,
        margin: 20,
      }}
    >
      <Typography variant="h5" style={{ padding: 10, fontWeight: 'bold' }}>
        {isRTL ? 'المخزن' : 'Stock'}
      </Typography>
      <Grid rows={rentitems} columns={columns} getRowId={getRowId}>
        <SortingState />
        <IntegratedSorting />
        <Table
          messages={{
            noData: isRTL ? 'لا يوجد بيانات' : 'no data',
          }}
          tableComponent={TableComponent}
          rowComponent={(props: any) => <Table.Row {...props}></Table.Row>}
          columnExtensions={tableColumnExtensions}
        />
        <TableColumnReordering
          defaultOrder={[
            'photo',
            col.name.name,
            col.category.name,
            'price',
            'unit',
            'qty',
            'busy_qty',
            'stock_qty',
            'desc',
          ]}
        />
        <TableHeaderRow
          showSortingControls
          titleComponent={({ children }) => {
            return (
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {children}
              </Typography>
            );
          }}
        />
        <DataTypeProvider
          for={['price']}
          formatterComponent={currencyFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['stock_qty']}
          formatterComponent={({ row }: any) => (
            <div>{row?.qty - (row?.busy_qty || 0)}</div>
          )}
        ></DataTypeProvider>
      </Grid>
    </Paper>
  );
};
export default RentitemsStockAlsardal;
